module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('popup', {
    ref: "siteWorkflowModal",
    attrs: {
      "buttonText": "Add Site Workflow",
      "heading": "Add Site Workflow",
      "buttonIcon": "fa fa-plus",
      "buttonSize": "mini",
      "buttonStyle": "warning",
      "round": "",
      "show-cancel": false,
      "show-save": false
    }
  }, [_c('el-form', {
    attrs: {
      "label-width": "150px"
    }
  }, [(!_vm.siteId) ? _c('select-site', {
    model: {
      value: (_vm.selectedSite),
      callback: function($$v) {
        _vm.selectedSite = $$v
      },
      expression: "selectedSite"
    }
  }) : _c('el-form-item', {
    attrs: {
      "label": "Selected Site:"
    }
  }, [_c('b', [_vm._v(_vm._s(_vm.siteName ? _vm.siteName : ('Site ID: ' + _vm.siteId)))])]), _vm._v(" "), _c('select-organisation', {
    model: {
      value: (_vm.selectedOrgId),
      callback: function($$v) {
        _vm.selectedOrgId = $$v
      },
      expression: "selectedOrgId"
    }
  }), _vm._v(" "), _c('select-workflow', {
    on: {
      "change": _vm.listen
    },
    model: {
      value: (_vm.wf),
      callback: function($$v) {
        _vm.wf = $$v
      },
      expression: "wf"
    }
  }), _vm._v(" "), _c('el-form-item', [_c('el-button', {
    staticClass: "pull-right",
    attrs: {
      "type": "success"
    },
    on: {
      "click": _vm.createNew
    }
  }, [_vm._v("Add")])], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-261f2d4a"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/workflow/site/AddSiteWorkflow.vue
// module id = 1378
// module chunks = 0